var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0206 3.40991C8.71058 3.40991 6.02058 6.09991 6.02058 9.40991V12.2999C6.02058 12.9099 5.76058 13.8399 5.45058 14.3599L4.30058 16.2699C3.59058 17.4499 4.08058 18.7599 5.38058 19.1999C9.69058 20.6399 14.3406 20.6399 18.6506 19.1999C19.8606 18.7999 20.3906 17.3699 19.7306 16.2699L18.5806 14.3599C18.2806 13.8399 18.0206 12.9099 18.0206 12.2999V9.40991C18.0206 6.10991 15.3206 3.40991 12.0206 3.40991Z",
    stroke: "#222222",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8699 3.69994C13.5599 3.60994 13.2399 3.53994 12.9099 3.49994C11.9499 3.37994 11.0299 3.44994 10.1699 3.69994C10.4599 2.95994 11.1799 2.43994 12.0199 2.43994C12.8599 2.43994 13.5799 2.95994 13.8699 3.69994Z",
    stroke: "#222222",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0195 19.5601C15.0195 21.2101 13.6695 22.5601 12.0195 22.5601C11.1995 22.5601 10.4395 22.2201 9.89953 21.6801C9.35953 21.1401 9.01953 20.3801 9.01953 19.5601",
    stroke: "#222222",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.3ce7bd8ff27e62d0d7266bb94c604dc8.svg";
export { ForwardRef as ReactComponent };